import { TaskGateway } from './task-gateway.interface';

const baseUrl = 'gk/tasks';
export class HttpTaskGateway implements TaskGateway {
  getAllTasksByUser(args: {
    filter: any;
    timeFilter: any;
    search: any;
    types: any;
    userId: any;
    imperative: any;
    groupName: string;
  }) {
    return {
      url: `${baseUrl}`,
      method: 'GET',
      params: {
        filter: args.filter,
        search: args.search,
        filters: args.types.length > 0 ? args.types.join(',') : null,
        timeFilter: args.timeFilter,
        userId: args.userId,
        imperative: args.imperative,
        groupName: args.groupName,
      },
    };
  }

  getTaskType() {
    return { url: `${baseUrl}/task-type`, method: 'GET' };
  }

  getTaskByProject(args: { projectId: string; groupName: string }) {
    return {
      url: `${baseUrl}/project/${args.projectId}`,
      method: 'GET',
      params: { groupName: args.groupName },
    };
  }

  getTasksTypesByUser() {
    return { url: `${baseUrl}/filters/types`, method: 'GET' };
  }

  validateTask(args: { taskId: string; data: any }) {
    return {
      url: `${baseUrl}/validate/${args.taskId}`,
      method: 'POST',
      data: args.data,
    };
  }

  postTask(args: { projectId: string; slug: string }) {
    return {
      url: `${baseUrl}/create/${args.projectId}/slug/${args.slug}`,
      method: 'POST',
    };
  }

  patchTask(args: { taskId: string; task: any }) {
    return {
      url: `${baseUrl}/${args.taskId}`,
      method: 'PATCH',
      data: args.task,
    };
  }

  patchWelcomeCall(args: { projectId: string; date: any }) {
    return {
      url: `${baseUrl}/welcome-call/${args.projectId}/update`,
      method: 'PATCH',
      data: { date: args.date },
    };
  }

  noShowWelcomeCallEx(args: { projectId: string }) {
    return {
      url: `${baseUrl}/welcome-call/${args.projectId}/exp-no-show`,
      method: 'POST',
    };
  }

  noShowWelcomeCall(args: { projectId: string }) {
    return {
      url: `${baseUrl}/welcome-call/${args.projectId}/no-show`,
      method: 'POST',
    };
  }

  patchTaskPieceComplementaire(args: { projectId: string; date: Date }) {
    return {
      url: `${baseUrl}/${args.projectId}/piece-complementaire`,
      method: 'PATCH',
      data: { date: args.date },
    };
  }

  deleteTask(args: { taskId: string }) {
    return {
      url: `${baseUrl}/${args.taskId}`,
      method: 'DELETE',
    };
  }
}
